import { LVTMetricEvent, Scope } from './types';

export const LVT_METRIC_EVENT: LVTMetricEvent = 'lvt_metric';
export const LVT_METRIC_SCOPE: Scope = 'learning_platform_frontend';
